/* The mockup's `.btn` family: 32px controls, 13px medium text, the control radius. */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  block-size: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  font: inherit;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition:
    background var(--motion-duration),
    border-color var(--motion-duration),
    color var(--motion-duration);
}

/* The focus ring is a token, so it moves with the theme and stays visible on
   every surface. `outline-offset` keeps it off the border it surrounds. */
.button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* A loading button looks disabled but keeps the focus (see `Button`). */
.button:disabled,
.button[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.5;
}

.sm {
  block-size: 28px;
  padding: 0 10px;
}

.md {
  padding: 0 var(--space-3);
}

.iconOnly {
  inline-size: var(--control-height);
  padding: 0;
}

.sm.iconOnly {
  inline-size: 28px;
}

.primary {
  background: var(--action-surface);
  border-color: var(--action-surface);
  color: var(--text-inverse);
}

.primary:hover:not(:disabled) {
  background: var(--action-surface-hover);
  border-color: var(--action-surface-hover);
}

.secondary {
  background: var(--surface-raised);
  color: var(--text);
  border-color: var(--border-strong);
}

.secondary:hover:not(:disabled) {
  background: var(--surface-sunken);
}

.ghost {
  background: transparent;
  color: var(--text-muted);
}

.ghost:hover:not(:disabled) {
  background: var(--state-hover);
  color: var(--text);
}

.danger {
  background: var(--surface-raised);
  color: var(--danger-text);
  border-color: var(--border-strong);
}

.danger:hover:not(:disabled) {
  background: var(--danger-surface);
}
